import { iBooking } from "@sdk/bookings/booking-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { bookingsDefaultQueryConfig } from "./bookings-default-query";

export const {
  slice: BookingsSlice,
  reducers: BookingsSliceReducer,
  actions: {
    setEntityQueryResults: setBookingsQueryResults,
    setEntity: setBooking,
    setEntities: setBookings,
    patchEntity: patchBooking,
    addNewEntity: addNewBooking,
    setEntityFetchingStatus: setBookingFetchingStatus,
    setEntitiesFetchingStatus: setBookingsFetchingStatus,
    setEntityFailedStatus: setBookingFailedStatus,
    setEntityQueryError: setBookingsQueryError,
    resetQuery: resetBookingsQuery,
    setQueryList: setBookingQueryList,
  },
} = CreateEntitySlice<iBooking>({
  sliceName: "bookings",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...bookingsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
